import { render, staticRenderFns } from "./CertListItem.vue?vue&type=template&id=27a6d2dc&scoped=true"
import script from "./CertListItem.vue?vue&type=script&lang=js"
export * from "./CertListItem.vue?vue&type=script&lang=js"
import style0 from "./CertListItem.vue?vue&type=style&index=0&id=27a6d2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6d2dc",
  null
  
)

export default component.exports